import { PERMISSIONS } from '@/generated/permissions'

export const projectRoutes = [
  {
    component: () => import('@/domains/projects/namer/pages/IndexPage.vue'),
    meta: { anyPerm: [PERMISSIONS.PROJECT_NAMER_MANAGE], requiresAuth: true },
    name: 'project-namer',
    path: '/project-namer',
  },
  {
    component: () => import('@/domains/projects/starter/pages/IndexPage.vue'),
    meta: { anyPerm: [PERMISSIONS.PROJECT_STARTER_MANAGE], requiresAuth: true },
    name: 'project-starter',
    path: '/project-starter',
  },
  {
    component: () =>
      import('@/domains/projects/mqtt-topic/pages/IndexPage.vue'),
    meta: { anyPerm: [PERMISSIONS.PROJECT_NAMER_MANAGE], requiresAuth: true },
    name: 'mqtt-topic-generator',
    path: '/mqtt-topic-generator',
  },
]
